import qs from 'qs';
import Modal from '../UiKit/Elements/Modal/Modal';

const DEVELOPER_QUESTION_MODAL_ID = 'developer-question-popup';

class DeveloperQuestionPopup {
  constructor(trigger, options = {}) {
    if (!trigger) return;
    this.trigger = trigger;
    this.options = options;
    this.attachListener();
  }

  attachListener() {
    this.trigger.addEventListener('click', (event) => {
      event.preventDefault();
      this.open();
    });
  }

  open = () => {
    const { trigger, options } = this;
    if (options.beforeShow) {
      options.beforeShow();
    }
    this.modal = new Modal(DEVELOPER_QUESTION_MODAL_ID, {
      onShow: (content) => {
        const { eventAction, callMeBack } = trigger.dataset;
        const searchParams = qs.parse(window.location.search.split('?')[1]);
        const developerQuestionSearchParams = {
          from: window.location.href,
          eventCategory: window.eventCategory,
          eventAction,
          gclid: searchParams.gclid,
        }
        if (!window.isMobile) {
          developerQuestionSearchParams.isDesktop = true;
        }
        if (this.options.isQuestionFromFlats) {
          developerQuestionSearchParams.isQuestionFromFlats = true;
        }
        if (callMeBack) {
          developerQuestionSearchParams.callMeBack = true;
        }
        const developerQuestionUrl = window.params.developerQuestionUrl || trigger.href;
        let link = `${developerQuestionUrl}/only-form?${qs.stringify(developerQuestionSearchParams)}`;
        const chips = trigger.dataset.developerQuestionChips;
        const placeOnPage = trigger.dataset.developerQuestionPlaceOnPage;
        if (chips) link += `&${chips}`;
        if (placeOnPage) link += `&${placeOnPage}`;
        content.innerHTML = `<iframe src="${link}" class="DeveloperQuestionPopup-frame"></iframe>`;
      },
      onClose: () => {
        if (options.onClose) {
          options.onClose();
        }
      },
    });
    window.addEventListener('message', this.onMessageQuestionPopup, false);
  }

  onMessageQuestionPopup = (event) => {
    if (event.data === 'closePopup') {
      this.modal?.close();
      window.removeEventListener('message', this.onMessageQuestionPopup);
    }
  };
}

export const initDeveloperQuestion = (root = document, options = {}) => {
  const developerQuestionTriggers = [
    ...root.querySelectorAll('[data-developer-question-popup-trigger]'),
  ];
  developerQuestionTriggers.forEach((trigger) => new DeveloperQuestionPopup(trigger, options));
};

initDeveloperQuestion();
